import { render } from "./UpdateConfirm.vue?vue&type=template&id=5bb51d3b&scoped=true&ts=true"
import script from "./UpdateConfirm.vue?vue&type=script&lang=ts"
export * from "./UpdateConfirm.vue?vue&type=script&lang=ts"

import "./UpdateConfirm.vue?vue&type=style&index=0&id=5bb51d3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb51d3b"]])

export default __exports__